import { SET_DEALER_ID } from '../actions/types';

export default function dealerId(state = '', action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_DEALER_ID:
				return action.payload;

			// no default
		}
	}

	return state;
}
